//mypreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#E7EDF2',
      100: '#CFDBE6',
      200: '#A4BBCF',
      300: '#7497B6',
      400: '#5FA8D3',
      500: '#0F4C81',
      600: '#0D3D68',
      700: '#0C3356',
      800: '#0B2A47',
      900: '#0A2239',
      950: '#071625',
    },
  },
});

export default MyPreset;
